import axios from "axios";

const { REACT_APP_API_URL } = process.env;

export const GET_ALL_URL = `${REACT_APP_API_URL}auth/groups`;

export function getAll(text = "") {
  return axios.get(`${GET_ALL_URL}?${text ? `text=${text}` : ""}`);
}

export function reset2fa(id) {
  return axios.post(`${REACT_APP_API_URL}users/reset2fa?id=${id}`);
}